import { initFederation as initNativeFederation } from '@angular-architects/native-federation';

export async function initializeFederationRuntimes(): Promise<void> {
  await initNativeFederation('manifest.json');
}
